


















import { computed, defineComponent } from '@vue/composition-api'
import {
  onMounted,
  PropType,
  ref,
  toRefs,
  useContext,
  watch,
} from '@nuxtjs/composition-api'
import InputSelect from '../Inputs/InputSelect.vue'
import { OfficeOption } from '@/components/FormInput/BlockNearestOffice.typing'
import { CityModel } from '@/contracts/api/QueryCites/QueryCities.Response'
import { OfficeModel } from '@/contracts/api/QueryOffices/QueryOffices.Response'

export default defineComponent({
  components: {
    InputSelect,
  },
  props: {
    productType: {
      type: String,
      default: null,
    },
    officeType: {
      type: String,
      default: null,
    },
    value: {
      type: Object as PropType<OfficeModel>,
      default: null,
    },
    city: {
      type: Object as PropType<CityModel>,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { disabled, city } = toRefs(props)
    const { $api } = useContext()

    const options = ref<OfficeOption[]>([])
    const loading = ref<boolean>(false)
    const errorMsg = ref<false | string>(false)

    const placeholder = computed<string>(() =>
      loading.value ? 'Загрузка...' : 'Ничего не выбрано'
    )

    const fetchCities = async (): Promise<void> => {
      if (disabled.value || !city.value) {
        options.value = []
        return
      }

      try {
        loading.value = true
        const { data } = await $api.requests.getOffices({
          officeIds: city.value.value.offices_ids.map(Number).join(','),
          ...(props.productType ? { productType: props.productType } : {}),
          ...(props.officeType ? { type: props.officeType } : {}),
        })

        if (data.status === 200) {
          options.value =
            data.data?.map((office) => ({
              name: `${ office.ADDRESS } - ${ office.NAME }`,
              value: office,
            })) || []
        } else {
          errorMsg.value = 'Ошибка загрузки'
        }
      } catch (e) {
        errorMsg.value = 'Ошибка загрузки'
      } finally {
        loading.value = false
      }
    }

    const onChange = (event: OfficeOption) => {
      emit('input', event)
    }

    onMounted(fetchCities)
    watch(city, fetchCities)

    const isCompareOffice = (
      option: OfficeOption,
      data: OfficeModel | null
    ) => {
      return !!option && !!data && option.value.OFFICEID === data.value.OFFICEID
    }

    return {
      placeholder,
      options,
      errorMsg,
      loading,
      onChange,
      isCompareOffice,
    }
  },
})
